import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetQuotation } from '../../../_seivices';
import Layout from '../../shared/Layout';
import DataTable from 'react-data-table-component';
import { imagebaseurl } from '../../../_config';

const Quote = () => {
    const [loading, setLoading] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchGetEnquiry = async () => {
        setLoading(true);
        try {
            const data = await GetQuotation();
            setBlogData(data);
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGetEnquiry();
    }, [])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newRowsPerPage, page) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page);
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => ((currentPage - 1) * rowsPerPage) + index + 1,
            width: '80px',
            center: true,
            sortable: false
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Email Id',
            selector: row => row.emailId,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Contact No',
            selector: row => row.contactNo,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Country',
            selector: row => row.countryName,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Work Type',
            selector: row => row.workTypeName,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Budget Range',
            selector: row => row.budgetRangeName,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Work Start Date ',
            selector: row => row.startDate ? new Date(row.startDate).toISOString().slice(0, 10) : '',
            sortable: true,
            width: '200px'
        },
        {
            name: 'Description',
            selector: row => (
                <div style={{ wordWrap: 'normal' }} >{row.projectDescription}</div>
            ),
            sortable: true,
            width: '400px',
        },
        {
            name: 'Entry Date',
            selector: row =>
                row.createdDate ? new Date(row.createdDate).toISOString().slice(0, 10) : '',
            sortable: true
        },
        {
            name: 'Action',
            selector: row => (
                <div style={{ wordWrap: 'normal' }}  >  <Link target='_blank' to={`${imagebaseurl}${row.filePath}`}> View</Link></div>
            ),
            sortable: true,
            width: '100px',
        },
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Quotation Detail</h4>
                    </div>
                </div>
            </div>

            <div className="datatable mt-3">
                <DataTable
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 220px)"
                    columns={columns}
                    data={blogData || []}
                    progressPending={loading}
                    progressComponent={<p>Loading...</p>}
                    pagination
                    paginationPerPage={rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    highlightOnHover
                />
            </div>
        </Layout>
    );
};

export default Quote;

